export function getBandByScore(score, language, scoreBand) {
  let band;
  if (scoreBand && scoreBand.size && scoreBand.size !== 0) {
    scoreBand.forEach((level) => {
      if (score >= level.get('scorePercentageFrom') &&
        score < level.get('scorePercentageTo') &&
        level.get('language') === language) {
        band = level;
      } else if (score === 100 &&
        score === level.get('scorePercentageTo') &&
        level.get('language') === language) {
        band = level;
      }
    });
  }
  return band;
}

export function getScoreBand(state, id) {
  return state.get('rootReducer').get('scoreBand').get(id);
}



// WEBPACK FOOTER //
// ./data/ScoreBand/accessors.js